import React from "react";
import ScrollReveal from "@/components/ScrollReveal";

interface IdeaBlockProps {
  id?: string;
  tint?: boolean;
  eyebrow?: string;
  statement: React.ReactNode;
  children: React.ReactNode;
}

const IdeaBlock: React.FC<IdeaBlockProps> = ({ id, tint, eyebrow, statement, children }) => {
  return (
    <section
      id={id}
      className={`py-24 md:py-32 px-6 relative overflow-hidden ${tint ? "bg-cosmic-900/30" : ""}`}
    >
      {tint && <div className="absolute inset-0 z-[-1] bg-cosmic-radial opacity-20" />}
      <div className="container mx-auto max-w-3xl text-center">
        {eyebrow && (
          <ScrollReveal>
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium tracking-wide text-cosmic-200 border border-cosmic-400/30 bg-cosmic-900/50 backdrop-blur-sm mb-6">
              {eyebrow}
            </span>
          </ScrollReveal>
        )}
        <ScrollReveal delay={100}>
          <h2 className="text-4xl md:text-5xl font-display font-bold leading-tight text-white max-w-[20ch] mx-auto">
            {statement}
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={250}>
          <div className="mt-8 text-lg text-white/70 leading-relaxed space-y-5 max-w-2xl mx-auto">
            {children}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default IdeaBlock;
